<template>
    <v-card height="100%">
        <v-toolbar class="darken-4" color="indigo" dark>
            <v-toolbar-title>
                {{$t('accumulated')}} {{$t('report')}}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn @click="dialogueClose" dark text>
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <div style="text-align:center">
            <h2>आ.ब.{{showNextYear?YearPreviousCurrentNext.next:setYearValue}} को {{reportTitle}}</h2>
        </div>
        
        <table border="1" class="table tbl" id="tblAccumulatedData">
            <thead class="sticky-div" v-if="groupLevel==1 || groupLevel==2">
                <tr>
                    <th rowspan="2">क्र सं</th>
                    <template v-for="(header,index) in headers">
                        <th :colspan="header.listCount" style="" v-bind:key="index+'headers'"
                            v-if=" header.groupID > 0 ">
                            <span v-if="header.showYear=='Next' && header.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='Current' && header.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='Previous' && header.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                            </span>

                            <!--NEW-->
                            <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                            </span>
                            <!--END NEW-->

                            <span v-else> {{ header.groupName }}</span>

                        </th>
                        <template v-else>
                            <template v-for="(column, subindex) in header.subList">
                                <th rowspan="2" style="" v-bind:key="index+'sub'+subindex">
                                    <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>
                                    <!--END NEW-->


                                    <span v-else> {{ column.name }}</span>
                                </th>
                            </template>

                        </template>
                    </template>
                </tr>
                <tr>
                    <template v-for="(column, colsHeadersIndex) in colsHeaders">
                        <th :key="colsHeadersIndex+'colsheader'" style="" v-if=" column.subTitleID>0 ">
                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                            </span>

                            <!--NEW-->
                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                            </span>

                            <!--END NEW-->


                            <span v-else> {{ column.name }}</span>
                        </th>
                    </template>
                </tr>
            </thead>
            <thead class="sticky-div" v-if="groupLevel==3">
                <tr>
                    <th rowspan="3">क्र सं</th>
                    <template v-for="(header,headerIndex1) in headers">
                        <th :colspan="header.listCount" style="" v-bind:key="headerIndex1+'headerIndex1'"
                            v-if="header.groupID>0 ">
                            <span v-if="header.showYear=='Next' && header.yearType=='Parent'">
                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='Current' && header.yearType=='Parent'">
                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='Previous' && header.yearType=='Parent'">
                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ header.groupName }}
                            </span>
                            <!--NEW-->
                            <span v-else-if="header.showYear=='TwoYear' && header.yearType=='Parent'">
                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ header.groupName }}
                            </span>
                            <span v-else-if="header.showYear=='ThreeYear' && header.yearType=='Parent'">
                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ header.groupName }}
                            </span>

                            <!--END NEW-->



                            <span v-else> {{ header.groupName }}</span>
                        </th>
                        <template v-else>
                            <template v-for="(column, indexheaderIndex) in header.list">
                                <th :colspan="column.subList.length" rowspan="2" style=""
                                    v-bind:key="headerIndex1+'indexheaderIndex'+indexheaderIndex" v-if="header.groupID>0">
                                    <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                                    </span>

                                    <!--NEW-->
                                    <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                                    </span>
                                    <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                        आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                                    </span>

                                    <!--END NEW-->

                                    <span v-else> {{ column.name }}</span>
                                </th>
                                <template v-else v-for="(subColumn, subColumnindex) in column.subList">
                                    <th rowspan="3" style="" v-bind:key="headerIndex1+'indexheaderIndex'+indexheaderIndex+'subColumnindex'+subColumnindex">
                                        <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                        </span>

                                        <!--NEW-->
                                        <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                        </span>
                                        <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                            आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                        </span>
                                        <!--END NEW-->


                                        <span v-else> {{ subColumn.name }}</span>
                                    </th>
                                </template>
                            </template>

                        </template>
                    </template>
                </tr>
                <tr>
                    <template v-for="(column, subColumnindex) in subColumns">
                        <th :colspan="column.subList.length" :key="'subColumnindex'+subColumnindex" style=""
                            v-if="column.groupID>0 ">
                            <span v-if="column.showYear=='Next' && column.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.groupName }}
                            </span>
                            <span v-else-if="column.showYear=='Current' && column.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.groupName }}
                            </span>
                            <span v-else-if="column.showYear=='Previous' && column.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.groupName }}
                            </span>
                            <!--NEW-->
                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.groupName }}
                            </span>
                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='Child'">
                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.groupName }}
                            </span>
                            <!--END NEW-->


                            <span v-else> {{ column.groupName }}</span>
                        </th>
                        <template v-for="(subColumn, subColumSubindex) in column.subList">
                            <th :key="'subColumnindex'+subColumnindex+'subColumSubindex'+subColumSubindex" rowspan="2" style=""
                                v-if="subColumn.titleID>0 && column.groupID==null">
                                <span v-if="subColumn.showYear=='Next' && subColumn.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.next}}  {{ subColumn.name }}
                                </span>
                                <span v-else-if="subColumn.showYear=='Current' && subColumn.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.current}}  {{ subColumn.name }}
                                </span>
                                <span v-else-if="subColumn.showYear=='Previous' && subColumn.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.previous}}  {{ subColumn.name }}
                                </span>

                                <!--NEW-->
                                <span v-else-if="subColumn.showYear=='TwoYear' && subColumn.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ subColumn.name }}
                                </span>
                                <span v-else-if="subColumn.showYear=='ThreeYear' && subColumn.yearType=='SubChild'">
                                    आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ subColumn.name }}
                                </span>
                                <!--END NEW-->

                                <span v-else> {{ subColumn.name }}</span>
                            </th>
                        </template>
                    </template>
                </tr>
                <tr>
                    <template v-for="(column,colsHeadersindex) in colsHeaders">
                        <th :key="'colsHeadersindex'+colsHeadersindex" style="" v-if="column.subTitleID>0 ">
                            <span v-if="column.showYear=='Next' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.next}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='Current' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.current}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='Previous' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.previous}}  {{ column.name }}
                            </span>

                            <!--NEW-->
                            <span v-else-if="column.showYear=='TwoYear' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.twoYear}}  {{ column.name }}
                            </span>
                            <span v-else-if="column.showYear=='ThreeYear' && column.yearType=='SubChild'">
                                आ.ब. {{YearPreviousCurrentNext.threeYear}}  {{ column.name }}
                            </span>

                            <!--END NEW-->

                            <span v-else> {{ column.name }}</span>
                        </th>
                    </template>
                </tr>
            </thead>

            <template v-for="(section,rowsindex) in rows">
                <tr :key="'rowsindex'+rowsindex">
                    <td :colspan="colsHeaders.length+1" style="background-color:#cdcdee;" v-if="section.reportSectionID>0">
                        <span> {{rowsindex+1}}. {{section.reportSection}}</span>
                    </td>
                </tr>
                <template v-for="(subSection,subindex) in section.list">
                    <tr :key="rowsindex+'sub'+subindex">
                        <td style="">{{subindex+1}}</td>
                        <td style="">{{subSection.reportSubSection}}</td>
                        <td :key="index" class="data-input" style=""
                            v-for="(rowsHeader, index) in subSection.list">
                            <span v-if="rowsHeader.dataType==2 || rowsHeader.dataType==4 || rowsHeader.dataType==5">
                                {{rowsHeader.amount | filterZero}}
                            </span>
                            <span v-else>{{rowsHeader.value | filterZero}}</span>
                        </td>
                    </tr>
                </template>
                <tr :key="rowsindex+'subtotal'">
                    <td colspan="2"><b> {{section.reportSection | filterZero}} जम्मा</b></td>
                    <td :key="rowsindex+'subTotals'+subTotalIndex" v-for="(subTotal,subTotalIndex) in section.totalSub" style="">{{subTotal.total | filterZero}}</td>
                </tr>
            </template>
            <tfoot>
                <tr class="tfoot">
                    <td colspan="2"><b>कुल जम्मा</b></td>
                    <td :key="totalIndex+'total'" v-for="(toalFooter,totalIndex) in totals" style="">
                        <b>{{toalFooter.total}}</b>
                    </td>
                </tr>
            </tfoot>
        </table>
    </v-card>
</template>

<script>
    import axios from "axios";

    export default {
        name: "anusucharuReportView",
        props: ["aunusucharuData"],
        data() {
            return {
                yearList: [],
                formData: {
                    name: "",
                    reportID: "",
                    year: ""
                },
                listDatas: [],
                message: {
                    status: true,
                    text: 'true',
                },
                rows: [],
                reportID: 0,
                reportTitle: "",
                totalRows: [],
                headers: [],
                colsHeaders: [],
                groupLevel: 0,
                totals: [],
                subColumns: [],
                setYearValue: "",
                showNextYear: false,
                YearPreviousCurrentNext: {}
            }
        },
        computed: {

            },
        validations: {

        },
          filters: {
            filterZero: function (value) {
                if (value!==0) {
                    return value
                }
                else{
                    return ''
                }

            }
        },
        mounted() {
              axios.get("ReportSettings/GetReportYearList").then(response => {
                    this.yearList = response.data
              })
            this.loadItems();
        },
        methods: {
            dialogueClose() {
                this.formData = {}
                this.$emit('dialogueCloseView')
            },
            setYear(year) {
                let yearValue = this.yearList.filter(function (item) {
                    return item.value === year;
                });
                this.setYearValue = yearValue[0].id;
            },
            getYearList(year) {
                if (this.yearList.length > 0) {
                    const currentYearIndex = this.indexWhere(this.yearList, item => item.value === year);
                    let previousThreeYearIndex = currentYearIndex - 3;
                    let previousTwoYearIndex = currentYearIndex - 2;
                    let previousYearIndex = currentYearIndex - 1;
                    let nextYearIndex = currentYearIndex + 1;
                    let previousCurrentNext = {};
                    this.yearList.forEach(function (data, yearIndex) {
                        if (currentYearIndex == yearIndex) {
                            previousCurrentNext.current = data.id
                        }
                        //NEW
                        if (previousTwoYearIndex == yearIndex) {
                            previousCurrentNext.twoYear = data.id
                        }
                        if (previousThreeYearIndex == yearIndex) {
                            previousCurrentNext.threeYear = data.id
                        }
                        //end NEW
                        if (previousYearIndex == yearIndex) {
                            previousCurrentNext.previous = data.id
                        }

                        if (nextYearIndex == yearIndex) {
                            previousCurrentNext.next = data.id
                        }

                    })
                    this.YearPreviousCurrentNext = previousCurrentNext;
                }

            },
            loadItems() {
                let formParams = {
                    "AnuSucharuReportID": this.aunusucharuData.anusucharuReportID,
                    fiscalYearID: this.aunusucharuData.fiscalYearID,
                    showAccumulatedReport: true
                }
                axios.post('AnusucharuReport/GetPolicyTwoColsRows', formParams).then(response => {
                    this.rows = response.data.anusucharuRows
                    this.headers = response.data.groupedColumns
                    this.totals = response.data.total;
                    this.colsHeaders = response.data.columns;
                    this.reportID = response.data.reportID;
                    this.reportTitle = response.data.reportTitle;
                    this.groupLevel = response.data.groupLevel;
                    this.subColumns = response.data.subColumns;
                    this.getYearList(response.data.year);
                    this.setYear(response.data.year);
                    this.showNextYear = response.data.showNextYear;
                })
            },
            indexWhere(array, conditionFn) {
                const item = array.find(conditionFn)
                return array.indexOf(item)
            },

        }
    }
</script>

<style lang="scss" scoped>
    .tbl {
        width: 90%;
        padding-left: 14em;
        margin-left: 3em;
        th {
            padding-top: 12px;
            padding-bottom: 12px;
            text-align: left;
            background-color: $main-color;
            color: white;
        }
    }

    table, td, th {
        border: 1px solid #ddd;
        text-align: left;
    }

    table {
        border-collapse: collapse;
        width: 100%;
    }

    th, td {
        padding: 15px;
    }

    .tfoot {
        background-color: #d2d2d2;
    }

    .tbl-btn{
        padding: 1em;
        text-align: right;
    }
</style>
